import React from 'react';

import { useTransition } from 'react-spring';
import { Container } from './styles';

import Toast from './Toast';
import { IToastMessage } from '../../../hooks/toast';

interface IToastProps {
  messages: IToastMessage[];
}

const ToastContainer: React.FC<IToastProps> = ({ messages }) => {
  const messageWithTransitions = useTransition(
    messages,
    message => message.id,
    {
      from: { right: '-120%', opacity: 0 },
      enter: { right: '0%', opacity: 1 },
      leave: { right: '-120%', opacity: 0 },
    },
  );

  return (
    <Container>
      {messageWithTransitions.map(({ item, key, props }) => (
        <Toast key={key} style={props} message={item} />
      ))}
    </Container>
  );
};

export default ToastContainer;
